import { arrayToObject } from 'shared-base';

export const authors = arrayToObject([
  { id: 1, nickname: 'MeshMaster', isPro: true },
  { id: 2, nickname: 'Pollyanna22', isPro: false },
  { id: 3, nickname: 'ShaderX', isPro: true },
  { id: 4, nickname: 'UV1', isPro: false },
  { id: 5, nickname: 'Vox', isPro: true },
  { id: 6, nickname: 'Bossy12', isPro: false },
  { id: 7, nickname: 'RayTray', isPro: true },
  { id: 8, nickname: 'AbnormalMap', isPro: false },
  { id: 9, nickname: 'SubDiva', isPro: true },
  { id: 10, nickname: 'Flasx718', isPro: false },
  { id: 11, nickname: 'Uvity', isPro: true },
  { id: 12, nickname: 'RiggedRex', isPro: false },
  { id: 13, nickname: 'DoughnutDev', isPro: true },
  { id: 14, nickname: 'XSpline', isPro: false },
  { id: 15, nickname: 'NotAnArtist', isPro: true },
  { id: 16, nickname: 'CtrlZK', isPro: false },
  { id: 17, nickname: 'CoffeeOverload', isPro: true },
  { id: 18, nickname: 'AFKForever', isPro: false },
]);
